import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Select } from 'antd'

import { headerColorRed, white } from '@Constants/ThemeColor'

export const NavMainWrapper = styled.div`
  padding: ${(props) =>
    props.xs ? '.3rem .3rem' : props.sm ? '1rem 3rem' : '1rem 5rem'};
`

export const NavWrapper = styled.div`
  display: flex;
  box-sizing: border-box;
  line-height: 32px;
  background-color: ${headerColorRed};
  border-radius: 0.3rem;
  padding: 0.3rem 0;
`

export const NavMenuWrapper = styled.div`
  display: flex;
  width: 75%;
  margin-left: 1rem;
`

export const ActionButtonsNavWrapper = styled.div`
  display: flex;
  width: 25%;
  justify-content: flex-end;
`

export const MarginWrapper = styled.div`
  margin-right: 1rem;
`

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${white};
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`

export const LanguageSelectorWrapper = styled(Select)`
  width: 125px;
`
